import { render } from "./Residence.vue?vue&type=template&id=71c8a7c4&scoped=true&ts=true"
import script from "./Residence.vue?vue&type=script&lang=ts"
export * from "./Residence.vue?vue&type=script&lang=ts"

import "./Residence.vue?vue&type=style&index=0&id=71c8a7c4&lang=less&scoped=true"

import exportComponent from "D:\\wamp\\UF\\uf-approve-h5\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-71c8a7c4"]])

export default __exports__